import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/App.css";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "./layouts/admin";
import SignInCentered from "views/auth/signIn";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./components/rtlProvider/theme/theme"
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";

import { Provider } from "react-redux";
import store from "./redux/store.js";
import { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { getUserDetails } from "./redux/actions/user";
import Loader from "./components/loader";
function App() {
  const dispatch = useDispatch();

  const loginData = useSelector((state) => state.userData);
  const loading = useSelector((state) => state.loaderData);

  useEffect(() => {
    let tokenFromSession = sessionStorage.getItem("token");
    let emailFromSession = sessionStorage.getItem("emailId");
    if (tokenFromSession && emailFromSession) {
      dispatch(
        getUserDetails({ token: tokenFromSession, emailId: emailFromSession })
      );
    }
  }, []);
  return (
    <>
      {/* {loading.loader ? (
        <Loader />
      ) : (
        <>
          {loginData?.isLoggedIn ? (
            <>
              <Switch>
                <Route path={`/auth`} component={SignInCentered} />
                <Route path={`/admin`} component={AdminLayout} />
                <Redirect from="/" to="/admin" />
              </Switch>
            </>
          ) : (
            <SignInCentered />
          )}
        </>
      )} */}
      <>
        {loginData?.isLoggedIn ? (
          <>
            <Loader loading={loading.loader} />
            <Switch>
              <Route path={`/auth`} component={SignInCentered} />
              <Route path={`/admin`} component={AdminLayout} />
              <Redirect from="/" to="/admin/" />
            </Switch>
          </>
        ) : (
          <>
            {loading.loader ? (
              <Loader loading={loading.loader} />
            ) : (
              <SignInCentered />
            )}
          </>
        )}
      </>
    </>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <ThemeEditorProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </ThemeEditorProvider>
      </React.StrictMode>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
